var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInIndia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_19523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V15H60V0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 15H0V30H60V15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 30H0V45H60V30Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28.5C26.6863 28.5 24 25.8137 24 22.5C24 19.1863 26.6863 16.5 30 16.5C33.3137 16.5 36 19.1863 36 22.5C36 25.8137 33.3137 28.5 30 28.5Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 27.75C27.1005 27.75 24.75 25.3995 24.75 22.5C24.75 19.6005 27.1005 17.25 30 17.25C32.8995 17.25 35.25 19.6005 35.25 22.5C35.25 25.3995 32.8995 27.75 30 27.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 23.55C29.4199 23.55 28.9498 23.0799 28.9498 22.5C28.9498 21.9201 29.4199 21.45 29.9998 21.45C30.5797 21.45 31.0498 21.9201 31.0498 22.5C31.0498 23.0799 30.5797 23.55 29.9998 23.55Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8301 23.4549C24.6823 23.4744 24.5467 23.3703 24.5272 23.2225C24.5077 23.0746 24.6118 22.939 24.7597 22.9195C24.9075 22.9001 25.0431 23.0041 25.0626 23.152C25.082 23.2998 24.978 23.4354 24.8301 23.4549Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9997 27.7501L29.8197 24.6001L29.9997 23.1001L30.1797 24.6001L29.9997 27.7501Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_19523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIndia);
export default __webpack_public_path__ + "static/media/in India.253e8c9905da6eb5f08b76c9acc0a001.svg";
export { ForwardRef as ReactComponent };